import { ENVIRONMENT } from '../environment/environment.service';
import { HttpClient } from '@angular/common/http';
import { Environment, Response, Conversation, Chat } from '@viso/core/models';
import { Inject, Injectable } from '@angular/core';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class MessagingService {

  constructor(
    private http: HttpClient,
    @Inject(ENVIRONMENT) private environment: Environment
  ) {}

  uploadImage(image: { base64: string; name: string; type: string }) {
    return this.http.post<{ status: number; url: string }>(
      `${this.environment.API_URL}/chat/upload-image`,
      image
    );
  } 
  
  editMessage(messageId: number, newMessage: string) {
    return this.http.put<Response<Chat>>(
      `${this.environment.API_URL}/chat/editMessage`,
      {
        message_id: messageId,
        new_message: newMessage
      }
    ).pipe(map(res => res.body));
  }

  deleteMessage(messageId: number) {
    return this.http.delete<Response<Chat>>(
      `${this.environment.API_URL}/chat/deleteMessage`,
      { body: { message_id: messageId } }
    ).pipe(map(res => res.body));
  }

  getConversationVendor() {
    return this.http
      .get(`${this.environment.API_URL}/chat/conversationVendor`)
      .pipe(map((res: Response<Conversation[]>) => res.body));
  }

  getConversationClient() {
    return this.http
      .get(`${this.environment.API_URL}/chat/conversationClient`)
      .pipe(map((res: Response<Conversation[]>) => res.body));
  }

  getChat(chatServiceId: number, eventId?: number, vendorId?: number) {
    return this.http
      .post(`${this.environment.API_URL}/chat/getMessages`, {
        "chat_service_id": chatServiceId,
        'event_id': eventId,
        'vendor_id': vendorId
      })
      .pipe(map((res: Response<Chat>) => res.body));
  }
}
